import React from 'react';
import RCTooltip from 'rc-tooltip';

export default function Tooltip({
  tooltip,
  children,
  placement,
  showArrow,
  align,
  overlayStyle,
  onOpenChange,
}) {
  if (!tooltip) return children;
  return (
    <RCTooltip
      onOpenChange={onOpenChange}
      overlayStyle={overlayStyle}
      align={align}
      showArrow={showArrow}
      placement={placement}
      overlay={<span>{tooltip}</span>}
    >
      {children}
    </RCTooltip>
  );
}
